import { createGlobalStyle } from "styled-components";
import { cssVariables } from "./theme";

export const Styles = createGlobalStyle`
    ${cssVariables}

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    * {
        box-sizing: border-box;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: var(--color-white);
        overflow-x: hidden;
        color: var(--color-text-secondary);
    }

    /* Modern scrollbar styling */
    ::-webkit-scrollbar {
        width: 8px;
    }

    ::-webkit-scrollbar-track {
        background: var(--color-background-alt);
    }

    ::-webkit-scrollbar-thumb {
        background: var(--color-primary);
        border-radius: var(--radius-full);
    }

    ::-webkit-scrollbar-thumb:hover {
        background: var(--color-primary-dark);
    }

    a {
        text-decoration: none;
        outline: none;
        color: var(--color-primary);
        transition: var(--transition-normal);

        &:hover {
            color: var(--color-primary-dark);
        }
    }

    input,
    textarea {
        border-radius: var(--radius-lg);
        border: 2px solid transparent;
        background: var(--color-background-alt);
        transition: var(--transition-normal);
        outline: none;
        width: 100%;
        padding: 1rem 1.25rem;
        font-family: inherit;
        font-size: 1rem;

        &:focus-within {
            background: var(--color-white);
            border-color: var(--color-primary);
            box-shadow: var(--shadow-glow);
        }

        &::placeholder {
            color: var(--color-text-muted);
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: var(--color-primary);
        line-height: 1.18;
        margin-top: 0;
    }

    h1 {
        font-size: 3.5rem;
        font-weight: 700;
        letter-spacing: -0.02em;

        @media only screen and (max-width: 890px) {
            font-size: 2.75rem;
        }

        @media only screen and (max-width: 414px) {
            font-size: 2rem;
        }
    }

    h2 {
        font-size: 2.5rem;

        @media only screen and (max-width: 890px) {
            font-size: 2rem;
        }

        @media only screen and (max-width: 414px) {
            font-size: 1.75rem;
        }
    }

    h3 {
        font-size: 2rem;

        @media only screen and (max-width: 414px) {
            font-size: 1.5rem;
        }
    }

    h4 {
        font-size: 1.5rem;
    }

    h5 {
        font-size: 1.25rem;
    }

    h6 {
        font-size: 1rem;
    }

    p {
        color: var(--color-text-secondary);
        font-size: 1.125rem;
        line-height: 1.7;
    }

    /* Selection styling */
    ::selection {
        background: var(--color-secondary);
        color: var(--color-text-dark);
    }

    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    /* Ant Design Drawer Customization */
    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
        background: var(--color-white);
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    .ant-drawer-header {
        background: var(--color-white);
        border-bottom: 1px solid var(--color-background-alt);
    }

    .ant-drawer-close {
        color: var(--color-primary);
    }

    /* Modern button base styles */
    button {
        cursor: pointer;
        font-family: inherit;
        transition: var(--transition-normal);
    }

    /* Smooth scroll behavior */
    html {
        scroll-behavior: smooth;
    }

    /* Animation utility classes */
    .fade-in {
        animation: fadeIn 0.6s ease-out forwards;
    }

    .slide-up {
        animation: slideUp 0.6s ease-out forwards;
    }

    .scale-in {
        animation: scaleIn 0.5s ease-out forwards;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes slideUp {
        from {
            opacity: 0;
            transform: translateY(30px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes scaleIn {
        from {
            opacity: 0;
            transform: scale(0.9);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    /* Gradient text utility */
    .gradient-text {
        background: var(--gradient-text);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    /* Glass morphism utility */
    .glass {
        background: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
    }

    /* Card hover effect */
    .card-hover {
        transition: var(--transition-normal);

        &:hover {
            transform: translateY(-8px);
            box-shadow: var(--shadow-xl);
        }
    }
`;
